/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'arrow-top': {
    width: 32,
    height: 24,
    viewBox: '0 0 32 24',
    data: '<path pid="0" _fill="hsl(210,100%,50%)" d="M16 0l16 24H0"/>'
  }
})
